// Ideally the code in this package should be part of 'owa-mail-subject-picker' package
// but due to circular dependency we have this package which connects subject picker to
// other packages via one single action
export {
    isSubjectPickerSupported,
    isSubjectPickerButtonFlightEnabled,
    isSubjectPickerOnFocusFlightEnabled,
} from './utils/isSubjectPickerSupported';

export { logSubjectPickerInitInfo } from './utils/logSubjectPickerInitInfo';
